import { CatalogCard } from "../components/CatalogCard";
import { InteractiveDefinition } from "./interactiveDefinitions";

export function InteractiveCard({
  interactive,
  to,
  heading
}: {
  interactive: InteractiveDefinition;
  to: string;
  heading?: "h2" | "h3";
}) {
  const tags = [
    interactive.originalLanguage,
    interactive.originalFramework,
    interactive.originalYear
  ].filter((tag): tag is string => Boolean(tag));
  return (
    <CatalogCard
      heading={heading}
      title={interactive.title}
      description={interactive.desc}
      image={interactive.image}
      tags={tags}
      to={to}
      testId="interactive-card"
    />
  );
}
